import React  from 'react'
import DropDown from '../dropdown';
import {RoomExpenseType} from '../../../api/services/next'

const RoomExpensesDropDown = ({...rest}) => {			
            return <DropDown search  api={RoomExpenseType.GetRoomExpenseType} textField="Name" valueField="Id"  {...rest}/>
}

export default RoomExpensesDropDown

